import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useRouter } from 'next/router';
import { Actions, State, useMyAccountMenuItems, MyAccountMenuPosition, Selectors } from '@grandvisionhq/auth';
import { MediaQuery, Link } from '@grandvisionhq/common';
import { SubMenuLinks } from '@grandvisionhq/layout';
import { connect, useFeatureToggles } from '@grandvisionhq/state';

const elementName = 'myaccount-page-with-menu';
var PageWithMenu = ({ backRouteLinkAttributes , routes , logout , children , authState ,  })=>{
    const isTabletLandscapeAndUp = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const isUserLoggedIn = State.isLoggedIn(authState);
    const { isAABEnabled , isWishlistEnabled  } = useFeatureToggles();
    const { asPath: returnPath  } = useRouter();
    const menuItems = useMyAccountMenuItems({
        logout: ()=>logout(returnPath)
        ,
        position: MyAccountMenuPosition.Sidebar,
        routes,
        isUserLoggedIn,
        isAabEnabled: isAABEnabled,
        isWishlistEnabled
    });
    const _ref = backRouteLinkAttributes !== null && backRouteLinkAttributes !== void 0 ? backRouteLinkAttributes : {}, { label  } = _ref, linkRest = swcHelpers.objectWithoutProperties(_ref, [
        "label"
    ]);
    return /*#__PURE__*/ React.createElement("article", {
        className: elementName
    }, routes && isTabletLandscapeAndUp && /*#__PURE__*/ React.createElement(SubMenuLinks, {
        items: menuItems
    }), /*#__PURE__*/ React.createElement("div", {
        className: `${elementName}__content`
    }, backRouteLinkAttributes ? /*#__PURE__*/ React.createElement(Link, swcHelpers.extends({}, linkRest, {
        iconBefore: "chevron-left",
        className: elementName + '__back-link'
    }), label) : null, children));
};
const mapStateToProps = (state)=>({
        authState: Selectors.getAuth(state),
        routes: Selectors.getFormattedRoutes(state)
    })
;
const dispatchProps = {
    logout: Actions.LogoutActions.logOut
};
var PageWithMenu$1 = connect(mapStateToProps, dispatchProps)(PageWithMenu);

export { PageWithMenu, PageWithMenu$1 as default, dispatchProps, mapStateToProps };
//# sourceMappingURL=PageWithMenu.js.map
